import axios from "axios";
import React, { useEffect, useState } from "react";
import moment from "moment";
import { Dashboard_Client_Report } from "../../Configuration/API_URL";
import Header from "../../Components/Header";
import Sidebar from "../../Components/Sidebar";
import $ from "jquery";
import { Client_Search } from "../../Configuration/API_URL";
import ReportTableHeader from "../../Components/ReportTables/ReportTableHeader";
import Loader from "../../Components/Common/Loader";
import {
  AESEncryption,
  ApiResDecrypt,
  checkDateRange,
  compareDate,
  decryptData,
  encryptData,
  noDataFound,
} from "../../CommonMethhods/CommonMethods";
import TradeSummary from "../../Components/ReportTables/TradeSummary";
import { Constants } from "../../CommonMethhods/Constants";
import FromdateComponent from "./FromdateComponent";
import TodateComponent from "./TodateComponent";
import LoaderForSearch from "../../Components/Common/LoaderForSearch";
import { toast } from "react-toastify";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import { useDebounce } from "../../Components/useDebounce";
import { Partner_Reports } from "../../Configuration/Partner_URL";
import DurationChangeComponent from "./DurationChangeComponent";

function TradeSummaryReportSidebar() {
  const storeToken = localStorage.getItem("ssoToken");
  // const userType = localStorage.getItem("userType").toLowerCase();
  const userType = localStorage.getItem("partnerType").toLowerCase();
  const partnerRoleNew = localStorage.getItem("partnerRoleNew")?.toLowerCase();
  const partnerSsoToken = localStorage.getItem("partnerSsoToken");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [loader, setLoader] = useState(false);
  const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
  const [smallLoaderPdf, setSmallLoaderPdf] = useState(false);
  const [smallLoaderMail, setSmallLoaderMail] = useState(false);
  const [seg, setSeg] = useState("stocks");
  const [data, setData] = useState([]);
  const [errorResp, setErrorResp] = useState("");
  const [nameError, setNameError] = useState("");
  const [page, setPage] = useState(1);
  const [scrollLoader, setScrollLoader] = useState(false);
  const [clientList, setClientList] = useState([]);
  const [serverError, setServerError] = useState(false);
  const [count, setCount] = useState();
  const [clientCode, setClientCode] = useState("");
  const [show, setShow] = useState(false);
  const [mainError, setMainError] = useState(false);
  const [errorGrid, setErrorGrid] = useState(false);
  const [selection, setSelection] = useState("date");
  const [selectDuration,setSelectDuration]=useState("custom")
  const [totalValues, setTotalValues] = useState({
    totaBuylValue: 0,
    totalSellValue: 0,
    totalNetValue: 0,
  });
  const [customShow, setCustomShow] = useState(false)

  const debouncedValue = useDebounce(clientCode, 1000);
  useEffect(() => {
    handleClientName(debouncedValue);
  }, [debouncedValue]);

  if (fromDate === "" || toDate === "") {
    const current = new Date();
    const CurrentYear = current.getFullYear();
    const CurrentMonth = current.getMonth();
    if (CurrentMonth < 4) {
      const newYear = `04-01-${CurrentYear - 1}`;
      const date = `${
        current.getMonth() + 1
      }-${current.getDate()}-${current.getFullYear()}`;
      const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
      setFromDate(newYear);
      setToDate(date1);
    } else {
      const newYear = `04-01-${CurrentYear}`;
      const date = `${
        current.getMonth() + 1
      }-${current.getDate()}-${current.getFullYear()}`;
      const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
      if(selectDuration !== "custom"){
      setFromDate(newYear);
      setToDate(date1);
      }else{
        setCustomShow(true);
        const currentDate = moment();
    const from = moment().subtract(4, "days");
    setToDate(currentDate.format("MM-DD-YYYY"));
    setFromDate(from.format("MM-DD-YYYY"));
      }
    }
  }

  //  useEffect(() => {
  //   if (selectDuration === "custom") {
  //     setCustomShow(true);
  //     const currentDate = moment();
  //   const from = moment().subtract(4, "days");

  //   setToDate(currentDate.format("MM-DD-YYYY"));
  //   setFromDate(from.format("MM-DD-YYYY"));
  //   } else {
  //     setCustomShow(false);
  //   }
  // }, [selectDuration]);

  console.log(fromDate, "fromDate");
  

  //search api

  async function searchApiDetail(code, NoPage) {
    let payloadValue = {
      keyword: code,
      Status: "",
      PageNo: NoPage,
      PageSize: 10,
    };
    const partnerPayload = {
      clientCode: code,
      page: NoPage,
      pageSize: 10,
    };

    const encPayload =
      userType === "partner" || partnerRoleNew === "partner"
        ? encryptData(JSON.stringify(partnerPayload))
        : AESEncryption(payloadValue);
    try {
      const getSearchDetail = await axios.post(
        userType === "partner" || partnerRoleNew === "partner"
          ? Partner_Reports.Client_Search_Partner_URL
          : Client_Search.Search_URL,
        userType === "partner" || partnerRoleNew === "partner" ? encPayload : `"${encPayload}"`,

        {
          headers: {
            "Content-Type":
              userType === "partner" || partnerRoleNew === "partner" ? "text/plain" : "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );

      const res =
        userType === "partner" || partnerRoleNew === "partner"
          ? JSON.parse(decryptData(getSearchDetail?.data))
          : ApiResDecrypt(getSearchDetail?.data);
      if (res?.status === 0) {
        setCount(res?.data?.TotalCount);
        setNameError(false);
        if (page > 1) {
          setClientList((prev) => {
            return [...prev, ...res?.data?.clients];
          });
        } else {
          setClientList(res?.data?.clients);
        }
      } else {
        setNameError(res?.message);
      }
    } catch (error) {
    } finally {
      setScrollLoader(false);
      setMainError(false);
    }
  }

  const handleScroll = async (e) => {
    const a = e.target;
    if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight && !scrollLoader) {
      if (!(count <= 10 * page)) {
        setPage((prev) => prev + 1);
        setScrollLoader(true);
      }
    }
  };

  function handleClientName(data) {
    if (data) {
      searchApiDetail(data, 1);
      setScrollLoader(true);
      setClientList([]);
      setPage(1);
    }
  }

  useEffect(() => {
    if (page > 1) {
      searchApiDetail(clientCode, page);
    }
  }, [page]);

  //search api end

  //trade summary report api
  const getTradeSumaaryReport = async (fileView, mainLoader = true) => {
    setSmallLoaderExcel(fileView === "excel");
    setSmallLoaderPdf(fileView === "pdf");
    setSmallLoaderMail(fileView === "mail");
    setLoader(mainLoader && fileView === "grid");
    let payloadValue = {
      clientCode: clientCode,
      fromDate: fromDate,
      toDate: toDate,
      fileType: fileView,
      seg: seg,
      selection: selection,
    };
    let encPayload = AESEncryption(payloadValue);
    console.log(payloadValue, "payloadValue");
    
    try {
      const getDetails = await axios.post(
        Dashboard_Client_Report.TradeSummary_URL,
        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${partnerRoleNew === "partner" ? partnerSsoToken : storeToken}`,
            reserv: 1,
          },
        }
      );
      const res = ApiResDecrypt(getDetails?.data);
      if (res?.status === 0) {
        if (fileView === "grid") {
          if (selection === "script") {
            setTotalValues({
              totaBuylValue: res?.data?.totaBuylValue,
              totalSellValue: res?.data?.totalSellValue,
              totalNetValue: res?.data?.totalNetValue,
            });
          }
          if (seg === "stocks") {
            setData(res?.data?.eqList);
          } else if (seg === "curfo") {
            setData(res?.data?.curFoList);
          } else {
            setData(res?.data?.foList);
          }
          if (selection === "script" && seg === "curfo") {
            setData(res?.data?.curScriptFoList);
          }
        } else if (fileView === "excel") {
          window.open(res?.data, "_self", "noopener,noreferrer");
        } else if (fileView === "pdf") {
          window.open(res?.data, "_blank", "noopener,noreferrer");
        } else {
          toast.success("Mail sent successfully");
        }
      } else {
        setData([]);
        setTotalValues({});
        if (fileView !== "grid") {
          toast.error(res?.message);
        } else {
          setErrorGrid(res?.message);
        }
      }
    } catch (error) {
      setServerError(error?.message);
      if (fileView !== "grid") {
        toast.error(error?.message);
      }
    } finally {
      setLoader(false);
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
      setSmallLoaderMail(false);
    }
  };

  //trade summary report api end

  useEffect(()=>{
    if(selectDuration === "custom"){
    getTradeSumaaryReport("grid", true);
    }
  }, [selectDuration])

  // const handleOnClick0 = (e) => {
  //   setShow(false);
  //   if (clientCode) {
  //     if (e.target.value) {
  //       if(selectDuration){
  //       if (
  //         compareDate(fromDate) &&
  //         compareDate(toDate) &&
  //         checkDateRange(fromDate, toDate)
  //       ) {
  //         getTradeSumaaryReport(e.target.value, true);
  //         setErrorResp("");
  //       } else {
  //         setErrorResp("Please Select Correct Date");
  //       }
  //     }
  //     else{
  //     setErrorResp("Please Select Duration")
  //     }
  //   }
  //   } else {
  //     setMainError("Please Select Client Name/Code");
  //   }
  // };

  function checkMax30Days(fromDate, toDate) {
  const start = moment(fromDate, "MM-DD-YYYY");
  const end = moment(toDate, "MM-DD-YYYY");
  const diffDays = end.diff(start, "days");
  return diffDays <= 30;
}

  const handleOnClick = (e) => {
  setShow(false);

  if (selectDuration === "custom") {
    if (e.target.value) {
      if (
        compareDate(fromDate) &&
        compareDate(toDate) &&
        checkDateRange(fromDate, toDate)
      ) {
        if (!clientCode) {
          if (!checkMax30Days(fromDate, toDate)) {
            setErrorResp("Please select a date range of maximum 30 days");
            return;
          }
        }
        getTradeSumaaryReport(e.target.value, true);
        setErrorResp("");
        setMainError("");
      } else {
        setErrorResp("Please Select Correct Date");
      }
    }
  } 
  else {
    if (clientCode) {
      if (e.target.value) {
        if(selectDuration){
        if (
          compareDate(fromDate) &&
          compareDate(toDate) &&
          checkDateRange(fromDate, toDate)
        ) {
          getTradeSumaaryReport(e.target.value, true);
          setErrorResp("");
        } else {
          setErrorResp("Please Select Correct Date");
        }
      }else{
         setErrorResp("Please Select Duration");
      }
      }
    } else {
      setMainError("Please Select Client Name/Code");
    }
  }
};
  function formatDate(date) {
    return moment(date, "MM-DD-YYYY").format("YYYY-MM-DD");
  }

  const handleSegmentChange = (e) => {
    setData([]);
    setErrorGrid(false);
    setSeg(e.target.value);
    setServerError(false);
  };

  const handleSelectionChange = (e) => {
    setData([]);
    setErrorGrid(false);
    setServerError(false);
    setSelection(e.target.value);
  };

  const handleFromDateChange = (e) => {
    setData([]);
    setErrorGrid(false);
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setFromDate(d);
    setErrorResp("");
    setServerError(false);
  };
  const handleToDateChange = (e) => {
    setData([]);
    setErrorGrid(false);
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setToDate(d);
    setErrorResp("");
    setServerError(false);
  };

  const currentDate = new Date();
  const yyyy = currentDate.getFullYear();
  let mm = currentDate.getMonth() + 1;
  let dd = currentDate.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const FormatedDate = dd + "/" + mm + "/" + yyyy;
  const DateReverse = FormatedDate.split("/").reverse().join("-");
   const minDate = !clientCode ? moment().subtract(30, "days").format("YYYY-MM-DD") : undefined;

  // const minDate = moment().subtract(4, "days").format("YYYY-MM-DD");

  const onChangeDuration=()=>{
    setErrorGrid(false);
    setData([]);
    setErrorResp(false);
    setServerError(false);

  }

  console.log(selectDuration, customShow, "selectDuration");
  
  return (
    <>
      <Header portal={"RM"} />
      {/* <Sidebar /> */}
      <SingleSignOnSideBar />
      <main id="main-content" className="reports interest-report-wrapper trade">
        <div className="card-box">
          <div>
            <h2 className="report-title">{Constants.Trade_Summary_Report}</h2>
          </div>
          <div className="row input-field-wrapper">
            <div className="col-md-3 col-sm-3 col-6">
              <div className="row d-flex justify-content-between">
                <div className="form-group">
                  <label className="form-label">
                    {Constants.Client_Search}
                  </label>
                  <div className="rm-custom-dropdown">
                    <input
                      type="text"
                      name="search-text"
                      className="input-st"
                      placeholder="Search here..."
                      autoComplete="off"
                      value={clientCode}
                      onChange={(e) => {
                        setClientCode(e.target.value.toUpperCase());
                        setShow(true);
                        setErrorGrid(false);
                      }}
                      onInput={(e) => {
                      const start = e.target.selectionStart;
                      const end = e.target.selectionEnd;
                      let input = e.target.value;
                      input = input
                          .toUpperCase()
                          .replace(/[^A-Z0-9\s]/g, "")
                          .replace(/\s+/g, " ")
                          .trimStart()
                          .slice(0, 100);

                      e.target.value = input;
                      e.target.setSelectionRange(start, end);
                  }}
                    />
                    <button
                      className="rm-dropdown-btn"
                      onClick={() => setShow(!show)}
                    >
                      <span className="icon-right-arrow-triangle"></span>
                    </button>
                    {show && (
                      <>
                        <ul
                          className="rm-mapping-ap border-0"
                          onScroll={(e) => handleScroll(e)}
                        >
                          {clientList &&
                            clientList.map((item, i) => (
                              <li
                                key={i}
                                className="rm-maping-item-wrapper"
                                onClick={() => {
                                  setClientCode(item?.clientCode);
                                  setShow(false);
                                }}
                              >
                                {userType === "partner" || partnerRoleNew === "partner" ? 
                                <>
                                  <div> {item?.clientName}</div>
                                  <div> {item?.clientCode}</div>
                                </>
                              : 
                                <>
                                  <div> {item?.clientname}</div>
                                  <div> {item?.clientCode}</div>
                                </>
                              }
                              </li>
                            ))}
                          {scrollLoader && !loader && (
                            <div className="loader-center">
                              <LoaderForSearch />
                            </div>
                          )}
                          {nameError && !scrollLoader && (
                            <li
                              className="rm-maping-item-wrapper"
                              style={{
                                borderBottom: "none",
                                fontSize: "12px",
                              }}
                            >
                              {nameError}
                            </li>
                          )}
                        </ul>
                      </>
                    )}
                  </div>
                  {mainError && (
                    <span className="to-date-error">{mainError}</span>
                  )}
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-2 col-6">
              <div className="form-group">
                <label className="form-label">Segment:</label>
                <select onChange={handleSegmentChange}>
                  <option value="stocks">Equity</option>
                  <option value="fo">Derivative</option>
                  <option value="curfo">{Constants.Currency}</option>
                </select>
              </div>
            </div>
            <div className="col-md-3 col-sm-1 col-6">
              <div className="form-group">
                {/* <label className="form-label">Selection:</label> */}
                <select
                  onChange={handleSelectionChange}
                  style={{ padding: "5px" }}
                >
                  <option value="date">Date</option>
                  <option value="script">Scrip</option>
                </select>
              </div>
            </div>
            <div className="col-md-3 col-sm-3 col-6">
                        <div className="form-group">
                          <DurationChangeComponent
                            setCustomShow={setCustomShow}
                            setFromDate={setFromDate}
                            setToDate={setToDate}
                            onChangeDuration={onChangeDuration}
                            setSelectDuration={setSelectDuration}
                            selectDuration={selectDuration}
                          />
                        </div>
                        {errorResp&& !selectDuration && (
                    <span className="duration-date-error">{errorResp}</span>
                  )}
                        </div>
           {customShow && <div className="col-md-3 col-sm-3 col-6">
              <FromdateComponent
                fromDate={handleFromDateChange}
                formatDate={formatDate(fromDate)}
                DateReverse={DateReverse}
                clientWiseReportForCustomCalanderIcon={true}
                // minDate={minDate}
              />
            </div>}
            {customShow && <div className="col-md-3 col-sm-3 col-6">
              <TodateComponent
                toDate={handleToDateChange}
                formatToDate={formatDate(toDate)}
                DateReverse={DateReverse}
                errorResponse={errorResp}
                clientWiseReportForCustomCalanderIcon={true}
              />
            </div>}
          </div>
          <div className="text-center search-btn-wrapper">
            <button
              value="grid"
              className="send-message"
              onClick={handleOnClick}
            >
              {Constants.Search}
            </button>
          </div>

          <div>
            <ReportTableHeader
              showEmailBtn={true}
              smallLoaderExcel={smallLoaderExcel}
              smallLoaderMail={smallLoaderMail}
              smallLoaderPdf={smallLoaderPdf}
              handleOnClick={handleOnClick}
            />
          </div>
          <div className="for-grid-section">
            {loader ? (
              <div className="loader-alignment">
                <Loader />
              </div>
            ) : data && data.length > 0 ? (
              <div>
                <TradeSummary
                  data={data}
                  seg={seg}
                  selection={selection}
                  totalValues={totalValues}
                />
              </div>
            ) : serverError ? (
              <h4 className="report-error-message">
                {noDataFound(serverError)}
              </h4>
            ) : errorGrid ? (
              noDataFound(errorGrid)
            ) : (
              ""
            )}
          </div>
        </div>
      </main>
    </>
  );
}

export default TradeSummaryReportSidebar;
